import { SummaryProductContextService } from '../../../../shared/SummaryProductContext.service';
import { SummaryEndpointsService } from '../screens/ScreenNewSummary/SummaryEndpoints.service';
import { ANALYTICS_ENDPOINT_BY_CONTEXT } from '../constants';

export class DomainAnalyticsService {
  summaryEndpointsService: SummaryEndpointsService;

  constructor() {
    this.summaryEndpointsService = new SummaryEndpointsService();
  }

  getAnalyticsEndpointByContext = (context: string): string | undefined => {
    if (SummaryProductContextService.isSummaryProductContext(context)) {
      return this.summaryEndpointsService.getSummaryEndpointByContext(context);
    }

    return ANALYTICS_ENDPOINT_BY_CONTEXT[context];
  };

  isDomainAnalyticsAvailable = (context: string): boolean => {
    if (SummaryProductContextService.isSummaryProductContext(context)) {
      const [baseContext] = SummaryProductContextService.decodeContext(context);
      return !!ANALYTICS_ENDPOINT_BY_CONTEXT[baseContext];
    }

    return !!ANALYTICS_ENDPOINT_BY_CONTEXT[context];
  };
}
